import React from "react"

export interface IViewContext {
  isWithinPortal?: boolean
  basePath?: string
}

export const ViewContext = React.createContext<IViewContext>({
})
